import React from 'react'
import styled from 'styled-components'

import Media from '../../../utils/Media'
import CasestudyList from '../../shared/CasestudyList'
import { Container } from '../../shared/Container'
import Layout from '../../shared/Layout'
import PageHeader from '../../shared/PageHeader'
import Section from '../../shared/Section'

interface StaticNewIndexProps {
  notePosts: any
}

interface NoteItem {
  id: string
  name: string
  eyecatch: string
  noteUrl: string
}

const CasestudyArchiveTemplate: React.FC<StaticNewIndexProps> = ({
  notePosts,
}) => {
  const filteredItemList: NoteItem[] = notePosts.contents

  return (
    <Layout>
      <PageHeader
        label="導入事例"
        backgroundImage="/images/picture/casestudy_hero.jpg"
      />
      <StyledSection>
        <Container size="large">
          <CasestudyList items={filteredItemList} />
        </Container>
      </StyledSection>
    </Layout>
  )
}

export default CasestudyArchiveTemplate

const StyledSection = styled(Section)`
  padding: 0 0 150px;

  ${Media.mobileMiddle} {
    padding: 0 0 100px;
  }
`
